import {
  CONTROL_BUCKET,
  VARIANT_A_BUCKET,
  VARIANT_B_BUCKET,
  VARIANT_C_BUCKET,
  VARIANT_D_BUCKET
} from '../../experiments/header-copy';

export const headerCopy: { [index: string]: string } = {
  [CONTROL_BUCKET]: 'Get a real offer in\u00A02\u00A0minutes',
  [VARIANT_A_BUCKET]: 'Get a real offer in\u00A02\u00A0minutes',
  [VARIANT_B_BUCKET]: 'Sell your car the hassle free way',
  [VARIANT_C_BUCKET]: 'Sell your car online',
  [VARIANT_D_BUCKET]: 'Sell your car online'
};

export const subHeaderCopy: { [index: string]: string } = {
  [CONTROL_BUCKET]: 'We pick up your car. You get paid on the spot. ',
  [VARIANT_A_BUCKET]: 'Sell your car 100% online, no haggling, no headaches.',
  [VARIANT_B_BUCKET]: 'Get a real offer in minutes. No haggling, no headaches. ',
  [VARIANT_C_BUCKET]: 'Share a few details about your car and we’ll make you a real offer.',
  [VARIANT_D_BUCKET]: 'Get a real offer, right away. We’ll guide you through it.'
};
